import React, {useEffect, useState} from "react";
import Banner from "@atlaskit/banner";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import {appLicenceService} from "../api/AppLicenceService";

export const LicenseCheckInfo = () => {
    const [isLicenceInvalid, setIsLicenceInvalid] = useState(false);

    useEffect(() => {
        setTimeout(async () => {
            setIsLicenceInvalid(!(await appLicenceService.hasValidLicence()));
        }, 1000);
    }, []);

    return (<>
            {isLicenceInvalid && <Banner appearance="warning" icon={<WarningIcon label="" secondaryColor="inherit"/>}>
                You do not seem to have a valid license. This is a paid app since 2023.{' '}
                <a href={"https://seibert.biz/navigationforconfluencepaidversion"} target={"_blank"}>Please visit our info page</a> or obtain a license in the
                Atlassian Marketplace or with your trusted Atlassian solution partner.
            </Banner>}
        </>
    );
};
